module.exports = __webpack_public_path__ + "static/themes-subregions-do-d303f1e06604b877009394d77a61753f.png";